<div class="container">
  <div class="container-content content d-flex direction-column">

    <app-filter-panel
      [expanded]="showFilters"
      (expandedChange)="showFilters = $event"
      (search)="dashFilterRef.applyFilters()"
      (clear)="clearAllFilters(dashFilterRef)">

      <div filter-search class="fat-filter-search">
        <div class="fat-search-box">
          <!--<p class="ui-field-label">Buscar</p>-->
          <div class="fat-search-input-wrap">
            <app-svg-icon
              class="fat-search-icon"
              width="15px"
              height="15px"
              color="lightGray"
              src="assets/icons/search-icon.svg"
              alt="search">
            </app-svg-icon>
            <input
              class="ui-search-input fat-search-input"
              type="text"
              placeholder="Buscar por número do lote, consulta ou contrato"
              [formControl]="queryField"
              (change)="searchField(queryField.value)"
              (keyup.enter)="searchField(queryField.value)" />
          </div>
        </div>
      </div>

      <div filter-fields class="fat-filter-grid">
        <app-dash-filter
          #dashFilterRef
          [appearance]="'accordion'"
          [filterOptions]="filter"
          [showFilters]="true"
          [titleComponent]="title"
          [mode]="'invoicing'">
        </app-dash-filter>

        <div class="accordion-field fat-filter-field--range">
          <p class="ui-field-label">Período do Lote</p>
          <div class="fat-date-range">
            <app-c-input
              [formControl]="batchDateFrom"
              inputType="date"
              class="fat-date-input"
              label="Início">
            </app-c-input>
            <span class="fat-date-range__sep" aria-hidden="true">→</span>
            <app-c-input
              [formControl]="batchDateTo"
              inputType="date"
              class="fat-date-input"
              label="Fim">
            </app-c-input>
          </div>
        </div>
      </div>
    </app-filter-panel>

    <div class="fat-toolbar">
      <span *ngIf="canSendInvoicingEmail" class="fat-toolbar__selection">· {{ selectionLabel }}</span>

      <button
        type="button"
        class="ui-btn ui-btn--primary ui-btn--lg fat-toolbar__email"
        [disabled]="!canSendInvoicingEmail"
        (click)="handleSendInvoiceEmail()">
        <app-svg-icon
          src="../../../../assets/icons/email-icon.svg"
          color="secondary"
          width="18px"
          height="18px">
        </app-svg-icon>
        Enviar e-mail
      </button>

      <button type="button" class="ui-btn ui-btn--primary ui-btn--lg"
              (click)="exportToClipboardInvoicing()">
        <app-svg-icon
          src="../../../../assets/icons/download-icon.svg"
          color="white"
          width="16px"
          height="16px">
        </app-svg-icon>
        Exportar
      </button>
    </div>

    <div class="fat-table">
      <table>
        <thead>
          <tr>
            <th class="fat-table__check-col">
              <app-c-checkbox
                [checked]="checkAll"
                [disabled]="lotsList.length === 0"
                [controlDisabled]="lotsList.length === 0"
                [id]="'all'"
                (change)="changeInvoiceHeaderCheckbox()"></app-c-checkbox>
            </th>
            <th class="fat-table__left" [class.fat-table__sortable]="getHeaderItem('Banco')?.isOrder" (click)="toggleSort(getHeaderItem('Banco'))">
              <span class="fat-table__th-inner">Banco
                <app-svg-icon *ngIf="getHeaderItem('Banco')?.isOrder" [src]="sortIcon('Banco')" width="12px" height="13px" color="white"></app-svg-icon>
              </span>
            </th>
            <th [class.fat-table__sortable]="getHeaderItem('Lote')?.isOrder" (click)="toggleSort(getHeaderItem('Lote'))">
              <span class="fat-table__th-inner">Lote
                <app-svg-icon *ngIf="getHeaderItem('Lote')?.isOrder" [src]="sortIcon('Lote')" width="12px" height="13px" color="white"></app-svg-icon>
              </span>
            </th>
            <th [class.fat-table__sortable]="getHeaderItem('Tipo de Operação')?.isOrder" (click)="toggleSort(getHeaderItem('Tipo de Operação'))">
              <span class="fat-table__th-inner">Tipo de Operação
                <app-svg-icon *ngIf="getHeaderItem('Tipo de Operação')?.isOrder" [src]="sortIcon('Tipo de Operação')" width="12px" height="13px" color="white"></app-svg-icon>
              </span>
            </th>
            <th [class.fat-table__sortable]="getHeaderItem('Data do Lote')?.isOrder" (click)="toggleSort(getHeaderItem('Data do Lote'))">
              <span class="fat-table__th-inner">Data do Lote
                <app-svg-icon *ngIf="getHeaderItem('Data do Lote')?.isOrder" [src]="sortIcon('Data do Lote')" width="12px" height="13px" color="white"></app-svg-icon>
              </span>
            </th>
            <th>Data Envio E-mail</th>
            <th>Data Recebimento NF</th>
            <th [class.fat-table__sortable]="getHeaderItem('Valor Faturado')?.isOrder" (click)="toggleSort(getHeaderItem('Valor Faturado'))">
              <span class="fat-table__th-inner">Valor Faturado
                <app-svg-icon *ngIf="getHeaderItem('Valor Faturado')?.isOrder" [src]="sortIcon('Valor Faturado')" width="12px" height="13px" color="white"></app-svg-icon>
              </span>
            </th>
            <th [class.fat-table__sortable]="getHeaderItem('Qt. de Contratos')?.isOrder" (click)="toggleSort(getHeaderItem('Qt. de Contratos'))">
              <span class="fat-table__th-inner">Qtd. Contratos
                <app-svg-icon *ngIf="getHeaderItem('Qt. de Contratos')?.isOrder" [src]="sortIcon('Qt. de Contratos')" width="12px" height="13px" color="white"></app-svg-icon>
              </span>
            </th>
            <th [class.fat-table__sortable]="getHeaderItem('Status Faturamento')?.isOrder" (click)="toggleSort(getHeaderItem('Status Faturamento'))">
              <span class="fat-table__th-inner">Status Lote
                <app-svg-icon *ngIf="getHeaderItem('Status Faturamento')?.isOrder" [src]="sortIcon('Status Faturamento')" width="12px" height="13px" color="white"></app-svg-icon>
              </span>
            </th>
            <th class="fat-table__action-col"></th>
          </tr>
        </thead>
        <tbody *ngIf="!isLoading">
          <tr *ngFor="let lote of lotsList">
            <td class="fat-table__check-col">
              <span
                class="fat-check"
                [class.fat-check--disabled]="disabledCardFlag(lote)"
                [matTooltip]="disabledReason(lote) ?? ''"
                [matTooltipDisabled]="!disabledCardFlag(lote)">
                <app-c-checkbox
                  [checked]="checkCardFlag(lote)"
                  [disabled]="disabledCardFlag(lote)"
                  [id]="lote.BatchId"
                  [controlDisabled]="disabledCardFlag(lote)"
                  (change)="changeInvoiceCardCheckbox(lote.BatchId.toString())"></app-c-checkbox>
              </span>
            </td>
            <td class="fat-table__left">
              <span class="fat-table__bank">{{ lote.Bank || '-' }}</span>
              <span class="fat-table__subline">{{ lote.Bpo }}</span>
            </td>
            <td><span class="fat-table__strong">{{ lote.BatchNumber || '-' }}</span></td>
            <td>{{ lote.OperationType || '-' }}</td>
            <td class="fat-table__date">{{ lote.CreateDate ? (lote.CreateDate | systemDate: 'dd/MM/yyyy') : '-' }}</td>
            <td class="fat-table__date">{{ (lote.EmailInvoiceDate | systemDate: 'dd/MM/yyyy') || '-' }}</td>
            <td class="fat-table__date">{{ (lote.PaymentDate | date: 'dd/MM/yyyy') || '-' }}</td>
            <td class="fat-table__commission">{{ (lote.AmountTotal | currency: 'BRL') || '-' }}</td>
            <td>{{ lote.NumberOfContracts || '-' }}</td>
            <td class="fat-table__status-stack">
              <span class="fat-table__status-row">
                <app-status-badge [label]="lote.BatchStatus || '-'" [tone]="batchStatusTone(lote)" variant="outline"></app-status-badge>
                <span *ngIf="lote.IntegrationError" class="fat-table__error" [matTooltip]="lote.IntegrationMsg!">!</span>
              </span>
              <span *ngIf="lote.StatusOfOnlending" class="fat-table__status-row">
                <app-status-badge
                  [label]="lote.StatusOfOnlending"
                  [tone]="onlendingStatusTone(lote)"
                  variant="outline">
                </app-status-badge>
              </span>
            </td>
            <td class="fat-table__action-col">
              <button type="button" class="fat-table__view-btn" title="Abrir lote" (click)="openLote(lote)">
                <app-svg-icon src="assets/icons/edit-icon.svg" width="14px" color="white"></app-svg-icon>
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <app-skeleton *ngIf="isLoading" variant="table-row" [rows]="8" [columns]="headerItems.length"></app-skeleton>

      <div *ngIf="!isLoading && lotsList.length === 0" class="ui-empty-state">
        <span class="ui-empty-state__message">Não há lotes disponíveis</span>
      </div>
    </div>

    <ng-container *ngIf="count > lotsList.length">
      <app-scroll-pagination
        [count]="count"
        (viewMoreTrigger)="handlePagination($event)"></app-scroll-pagination>
    </ng-container>
  </div>
</div>
